<script setup>
import { ref } from 'vue';
import { trans } from '@tools/translation';

const emit = defineEmits([ 'delete' ]);
const deleteMode = ref(false);

const props = defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <div>
    <div v-show="deleteMode" class="row-actions-grouped__buttons">
      <button
        class="row-actions__delete-confirm btn--secondary red btn--with-icon"
        @click.prevent="emit('delete')"
      >
        <span>{{ trans('global.delete') }}</span>
      </button>
      <button
        class="row-actions__cancel btn btn--secondary"
        @click.prevent="deleteMode = !deleteMode"
      >
        <span>{{ trans('global.cancel') }}</span>
      </button>
    </div>
    <div v-show="!deleteMode" class="row-actions-grouped__buttons">
      <button
        class="row-actions__delete btn btn--secondary"
        :class="{ disabled: props.disabled }"
        :disabled="props.disabled"
        @click.prevent="deleteMode = !deleteMode"
      >
        <span>{{ trans('global.delete') }}</span>
      </button>
    </div>
  </div>
</template>
